/**
 * Shareable links to the drawer's panels.
 *
 * Hash routing rather than paths: the atlas is a static artefact that has to
 * work on any host — a CDN, object storage, a plain nginx in whichever region
 * the client settles on — and a hash needs no rewrite rule anywhere.
 *
 *   #/e/FRA        a country or supranational entity, keyed by ISO 3166-1 alpha-3
 *   #/region/MENA  a regional profile
 *   #/methodology  how the atlas is built
 *
 * ISO codes are the client's own join key, so a link stays valid even if an
 * entity is renamed.
 */
import { byIso, REGION_VIEW } from '../model.js';
import { flyToLL } from '../globe/scene.js';
import { closeDrawer, currentView, openCountry, openMethod, openRegion } from './drawer.js';
import { hashFor } from './hash.js';

function apply() {
  const hash = location.hash;
  if (hash === hashFor(currentView())) return;   // already showing it; nothing to do

  const entity = /^#\/e\/([A-Za-z]{3})$/.exec(hash);
  if (entity) {
    const c = byIso[entity[1].toUpperCase()];
    if (c) { openCountry(c); return }
  }
  const region = /^#\/region\/(.+)$/.exec(hash);
  if (region) {
    const name = decodeURIComponent(region[1]);
    if (REGION_VIEW[name]) {
      const [lat, lon] = REGION_VIEW[name];
      flyToLL(lat, lon, 2.3);
      openRegion(name);
      return;
    }
  }
  if (hash === '#/methodology') { openMethod(); return }
  if (!hash || hash === '#') closeDrawer();
}

export function initRoute() {
  addEventListener('hashchange', apply);
  if (location.hash) apply();   // a link opened cold lands on the right panel
}
